import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function PendingVerification() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const rejected = user?.status === "rejected";

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center px-5 sm:px-6 py-16" data-testid="pending-verification-page">
      <div className="w-full max-w-lg text-center cd-fade-in">
        <div className="flex justify-center mb-10">
          <Logo size={80} />
        </div>
        <div className="bg-white border border-sand rounded-sm p-8 sm:p-12">
          {rejected ? (
            <>
              <h1 className="font-serif text-3xl sm:text-4xl font-light text-charcoal" data-testid="rejected-title">
                Verifizierung nicht möglich
              </h1>
              <div className="mt-8 space-y-4 text-charcoal/70 leading-relaxed">
                <p>Vielen Dank für Ihre Registrierung.</p>
                <p>Nach sorgfältiger Prüfung konnten wir Ihr Konto derzeit leider nicht als gewerblichen Kunden verifizieren.</p>
                <p>Gerne klären wir offene Fragen gemeinsam mit Ihnen.</p>
              </div>
              <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
                <a href="mailto:info@canto-dei.com">
                  <Button className="w-full sm:w-auto bg-gold hover:bg-golddark text-white rounded-sm px-8 py-6 transition-colors duration-500" data-testid="rejected-contact-button">
                    Canto Dei kontaktieren
                  </Button>
                </a>
                <Button
                  onClick={handleLogout}
                  variant="outline"
                  className="w-full sm:w-auto border-gold text-gold hover:bg-gold hover:text-white rounded-sm px-8 py-6 transition-colors duration-500"
                  data-testid="pending-logout-button"
                >
                  Logout
                </Button>
              </div>
            </>
          ) : (
            <>
              <h1 className="font-serif text-3xl sm:text-4xl font-light text-charcoal">
                Konto wird geprüft
              </h1>
              <div className="mt-8 space-y-4 text-charcoal/70 leading-relaxed">
                <p>Ihr Konto wurde erfolgreich erstellt.</p>
                <p>Unser Team prüft derzeit Ihre Registrierung.</p>
                <p>Nach erfolgreicher Verifizierung erhalten Sie automatisch eine E-Mail.</p>
                <p>Bis dahin können noch keine individuellen personalisierten Trauersongs erstellt werden.</p>
              </div>
              <Button
                onClick={handleLogout}
                variant="outline"
                className="mt-10 border-gold text-gold hover:bg-gold hover:text-white rounded-sm px-10 py-6 transition-colors duration-500"
                data-testid="pending-logout-button"
              >
                Logout
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
